import React, {useId} from 'react'
import {MenuItem} from './MenuItem'
import {DefautlConfigHeader} from '../../core/_menu-config'
import {useAuth} from '../../../../../app/modules/auth'
import IUserService from 'src/app/services/user/service'
import {useQuery} from 'react-query'
import {getAllMenu} from '../../core/request-menu/core/request'
import Swal from 'sweetalert2'
import LoopRenderer from 'src/app/widgets/molecule/loop-rendering'
import {DataMenu} from '../../core/request-menu/types/role-types'
import {ConditinalRendering} from 'src/app/widgets/molecule/conditional-rendering'
import {Navigate} from 'react-router-dom'

interface CheckGuardProtectionParams {
  guards?: string[]
  guardBidang?: string[]
  guardSubBidang?: string[]
}

/**
 * This configuration for Nav bar Header Menu
 * you can set menu visible for role
 * like admin, operator, kasubbid, kabid, kecamatan, kelurahan, notaris, umum
 */

let useGetMenu = () => {
  return useQuery({
    queryKey: ['Get All Menu'],
    queryFn: async () => {
      const res = await getAllMenu()
      return res.data
    },
    onError: (err) => {
      Swal.fire({
        title: 'Gagal',
        icon: 'error',
        text: 'Gagal mengambil data menu navbar',
      })
    },
    refetchOnWindowFocus: false,
  })
}

const guardsForEmployee: String[] = [
  'admin',
  'kasubbid',
  'kabid',
  'superadmin',
  'notaris',
  'operator',
  'admin_bphtb',
]
const guardsForPublic: String[] = ['umum', 'kelurahan', 'kecamatan', 'survei_bphtb']

export function MenuInner() {
  const {auth} = useAuth()
  const id = useId()

  const checkGuardProtection = ({
    guardBidang,
    guardSubBidang,
    guards,
  }: CheckGuardProtectionParams): boolean => {
    if (!guards) return true
    const role = auth.user.role

    if (guardSubBidang && auth.user.nama_sub_bidang && auth.user.role !== IUserService.KASUBBID) {
      return guardSubBidang.includes(auth.user.nama_sub_bidang.toLowerCase())
    }

    if (guardBidang && auth.user.nama_bidang) {
      return guardBidang.includes(auth.user.nama_bidang.toLowerCase())
    }

    return guards.includes(role)
  }

  //* Note: Check this code later for menu Navbar from API

  // return (
  //   <>
  //     {useGetMenu()?.data?.map((data: DataMenu) => {
  //       return (
  //         <ConditinalRendering
  //           conditional={data.title.toLowerCase() === 'navbar'}
  //           onTrueComponent={
  //             <>
  //               <MenuItem title='Dashboard' to='/dashboard' key={id} />
  //               {data?.subItems?.map((subItem: DataMenu) => {
  //                 return (
  //                   checkGuardProtection({
  //                     guards: subItem.roles,
  //                     guardBidang: subItem.bidang,
  //                     guardSubBidang: subItem.sub_bidang,
  //                   }) && (
  //                     <MenuItem
  //                       title={subItem.title!}
  //                       to={subItem.link!}
  //                       key={subItem.title + subItem.link}
  //                     />
  //                   )
  //                 )
  //               })}
  //             </>
  //           }
  //           onFalseComponent={<></>}
  //         />
  //       )
  //     })}
  //   </>
  // )
  return (
    <>
      {DefautlConfigHeader.map((data) => {
        return (
          checkGuardProtection({
            guards: data.guards,
            guardBidang: data.guardBidang,
            guardSubBidang: data.guardSubBidang,
          }) && <MenuItem title={data.title!} to={data.link!} key={id} />
        )
      })}
    </>
  )
}
